import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import React from 'react';
import './CapGuidance.scss';

interface CapGuidanceProps {
    isCapGuidanceVisible: boolean;
    onHide: () => void;
};

const CapGuidance = ({ isCapGuidanceVisible, onHide }: Readonly<CapGuidanceProps>) => {
    const handleHide = () => {
        onHide();
    };
    const handlePrint = () => {
        const dialogContent = document.getElementById('CapGuidance');
        if (dialogContent) {
            dialogContent.classList.add('print-mode');
            setTimeout(() => {
                window.print();
            }, 100);
        }
    }
    return (
        <Dialog
            header={<div className="header-coaching" id='CapGuidance'>
                <h3>What is a CAP?</h3>
                <div>
                    <Button
                        data-testid='printButton'
                        icon="pi pi-print"
                        className="btn-primary me-2"
                        onClick={handlePrint}
                    />
                    <Button
                        type="button"
                        data-testid='closeButton'
                        className="btn-primary"
                        label="Return to CAPS"
                        aria-label="Return to CAPS"
                        role="button"
                        onClick={handleHide} />
                </div>
            </div>}
            visible={isCapGuidanceVisible}
            onHide={handleHide}
            closable={false}
            className="card shadow bg-body rounded mt-4 border-0 p-0 w-65"
            modal
            draggable={false}
            resizable={false}
            style={{width: '66vw',height: '90vh'}}>
            <hr />
            <div style={{ fontWeight: 400, marginLeft: '3px' }}>
                <p style={{ fontWeight: 800, marginBottom: '0px' }}>
                    Overview
                </p>
                <p>
                    As we continue to work toward creating a more robust reporting system, we’re writing to inform you of
                    recent changes made to our monthly Coaching Action Plan (CAP) compliance reporting guidelines. These
                    changes will assist us in enhancing our reporting capabilities and ensuring our leaders have more
                    visibility into CAP completions.</p>
                <p style={{ fontWeight: 800, marginBottom: '0px' }}>
                    Compliance Measurement</p>
                <p >
                    Moving forward, a completed CAP creation will be counted when <b>all</b> the following components are met:
                </p>
                <ul >
                    <li>One (1) Strength</li>
                    <li>One (1) Discussion Log categorized as ‘CAP’</li>
                    <li>One (1) Metric Review (for clients with a scorecard in Empower)</li>
                </ul>
                <p><b>Note:</b> Accounts with no scorecard in Empower will still need to complete the Strength and Discussion Log
                    requirements to be considered compliant.</p>
                <p>
                    The goal is to reach <b>95% compliance each month</b> with all the components above completed per
                    associate.
                </p>
                <ul>
                    <li> CAP acknowledged target is also 95%.</li>
                    <li>To be tagged as ‘in compliance,’ both CAP created and acknowledged need to be on target.</li>
                    <li>May, June and July compliance results are measured with all Discussion Log entries versus those
                        categorized as CAP. Beginning with August, compliance will be measured using only Discussion
                        Logs categorized as CAP or LOA (Leave of Absence).</li>
                </ul>
            </div>
        </Dialog>
    );
}
export default CapGuidance;